import { cn } from '../../utils/cn';

/**
 * Centred auth card shell — .pen Recuperar/Redefinir card (radius-xl, pad space-6).
 */
export function AuthCard({ children, className, badge }) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-space-5 rounded-ds-xl border border-border bg-card p-space-6 shadow-sm',
        className,
      )}
    >
      {badge ? (
        <div className="flex size-12 items-center justify-center rounded-ds-full bg-sage-tint text-sage-600">
          {badge}
        </div>
      ) : null}
      {children}
    </div>
  );
}

export function AuthCardHead({ title, subtitle, className }) {
  return (
    <div className={cn('flex flex-col gap-space-2', className)}>
      <h2 className="font-display text-type-title-page font-bold tracking-tight text-foreground">
        {title}
      </h2>
      {subtitle ? (
        <p className="text-type-body leading-relaxed text-muted-foreground">{subtitle}</p>
      ) : null}
    </div>
  );
}
